import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles, Typography, Divider } from '@material-ui/core';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';

import { TopActionBar, VimoTaskContent } from '../../common/components';

import TaskAvatar from './components/TaskAvatar';

const styles = theme => ({
    root: {
    },
    content: {
        padding: theme.spacing(4),
    },
    title: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: theme.spacing(2),
    },
    avatar: {
        marginRight: theme.spacing(1),
    },
    task: {
        marginBottom: theme.spacing(4),
    },
    divider: {
        backgroundColor: theme.colors.grey3,
        marginBottom: theme.spacing(4),
    },
});

class Today extends React.Component {
    render() {
        const {
            classes, translate, studentData, taskDetails,
        } = this.props;

        return (
            <div className={classes.root}>
                <TopActionBar title={translate('student.todaysTasks')} />

                <div className={classes.content}>
                    {studentData && studentData.todaysTasks.map((task, i) => (
                        <React.Fragment key={task.id}>
                            {i > 0 && <Divider className={classes.divider} />}
                            <div className={classes.task}>
                                <Typography variant="h6" className={classes.title}>
                                    <TaskAvatar task={task} className={classes.avatar} />
                                    {task.name}
                                </Typography>
                                {taskDetails && taskDetails[task.id] && <VimoTaskContent task={taskDetails[task.id]} />}
                            </div>
                        </React.Fragment>
                    ))}

                </div>

            </div>
        );
    }
}

Today.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    studentData: PropTypes.object,
    taskDetails: PropTypes.object,
};

Today.defaultProps = {
    studentData: null,
    taskDetails: null,
};

const mapStateToProps = (state, ownProps) => ({
    translate: getTranslate(state.localize),
    studentData: state.patient.details && state.patient.details[ownProps.match.params.studentId],
    taskDetails: state.program.taskDetails,
});

export default connect(mapStateToProps)(withStyles(styles)(Today));
